export const environment = {
    production: true,
    version: '1.0.0',
    baseUrl: 'https://api.statementzen.com/matching',
    uiBaseUrl: 'https://app.statementzen.com',
    wpUrl: 'https://statementzen.com',
    socketUrl: 'https://ws.statementzen.com',
    winFormsAppDownloadUrl: 'https://statementzen-updates.s3.ap-southeast-2.amazonaws.com/StatementZen-win-Setup.exe',
    winFormsAppVersionUrl: 'https://statementzen-updates.s3.ap-southeast-2.amazonaws.com/app-update.txt',
    encode: '',
    adobeClientId: '2310183fb92f44f3855452a3943ae0b8',

    // Sentry configuration
    sentry: {
        dsn: 'https://89314d74fbb344f4a410c01e0dbb52b9@glitchtip.statementzen.com/1',
        tracesSampleRate: 0.1, // 10% sampling in production
        debug: false,
        environment: 'production'
    },

    // Kinde PKCE auth configuration
    kinde: {
        authDomain: 'https://auth.statementzen.com',
        clientId: '9feee282b10c46a097e805e75632ad24',
        redirectUri: 'https://app.statementzen.com',
        logoutUri: 'https://app.statementzen.com',
        audience: 'https://api.statementzen.com',
    }
}